// Mock data for Vitality Pharmacy Software — standalone retail pharmacy (frontend teaser)
// NOTE: All data here is MOCKED and stored in-memory / localStorage.

export const BRAND = { name: 'Vitality Pharmacy Software', short: 'Vitality' };

// --- Auth mock users ---
export const MOCK_USERS = [
  { id: 'u-super', name: 'Super User', roleLabel: 'Super Admin', role: 'super_user', email: 'superadmin@vitality.ug', password: 'password', pharmacyId: null },
  { id: 'u-admin', name: 'Achieng Grace', roleLabel: 'Pharmacy Admin', role: 'pharmacy_admin', email: 'admin@kampala.ug', password: 'password', pharmacyId: 'ph-1' },
  { id: 'u-cashier', name: 'Okello Daniel', roleLabel: 'Cashier', role: 'cashier', email: 'cashier@kampala.ug', password: 'password', pharmacyId: 'ph-1' },
];

// --- Pharmacies (managed by super user) ---
export const MOCK_PHARMACIES = [
  { id: 'ph-1', name: 'Kampala Central Pharmacy', district: 'Kampala', licence: 'NDA-UG-10233', owner: 'Achieng Grace', phone: '+256 772 100 200', users: 6, status: 'active', createdAt: '2024-11-02' },
  { id: 'ph-2', name: 'Entebbe HealthPlus', district: 'Wakiso', licence: 'NDA-UG-10871', owner: 'Ssali Peter', phone: '+256 701 445 900', users: 4, status: 'active', createdAt: '2025-01-14' },
  { id: 'ph-3', name: 'Gulu Care Chemists', district: 'Gulu', licence: 'NDA-UG-11540', owner: 'Auma Betty', phone: '+256 782 330 118', users: 3, status: 'suspended', createdAt: '2025-02-20' },
  { id: 'ph-4', name: 'Mbarara Family Pharmacy', district: 'Mbarara', licence: 'NDA-UG-12002', owner: 'Tumusiime John', phone: '+256 758 620 774', users: 5, status: 'active', createdAt: '2025-03-08' },
];

// --- Staff users within a pharmacy (managed by pharmacy admin) ---
export const MOCK_STAFF = [
  { id: 's-1', name: 'Achieng Grace', email: 'admin@kampala.ug', role: 'pharmacy_admin', roleLabel: 'Pharmacy Admin', phone: '+256 772 100 200', status: 'active' },
  { id: 's-2', name: 'Okello Daniel', email: 'cashier@kampala.ug', role: 'cashier', roleLabel: 'Cashier', phone: '+256 701 220 331', status: 'active' },
  { id: 's-3', name: 'Nabirye Sarah', email: 'sarah@kampala.ug', role: 'pharmacist', roleLabel: 'Pharmacist', phone: '+256 772 884 110', status: 'active' },
  { id: 's-4', name: 'Mugisha Brian', email: 'brian@kampala.ug', role: 'cashier', roleLabel: 'Cashier', phone: '+256 758 990 221', status: 'active' },
  { id: 's-5', name: 'Kirabo Joan', email: 'joan@kampala.ug', role: 'stock_controller', roleLabel: 'Stock Controller', phone: '+256 782 771 004', status: 'inactive' },
];

export const STAFF_ROLES = [
  { value: 'pharmacy_admin', label: 'Pharmacy Admin' },
  { value: 'pharmacist', label: 'Pharmacist' },
  { value: 'cashier', label: 'Cashier' },
  { value: 'stock_controller', label: 'Stock Controller' },
];

// --- Product catalog (used by POS, Inventory, Catalog) ---
export const DRUG_CATEGORIES = ['Antibiotic', 'Analgesic', 'Antimalarial', 'Antidiabetic', 'Supplement', 'Rehydration', 'Antacid', 'Antihistamine', 'Vitamin'];

export const MOCK_PRODUCTS = [
  { id: 'D-01', name: 'Amoxicillin 500mg', generic: 'Amoxicillin', form: 'Capsule', category: 'Antibiotic', price: 500, stock: 320, reorder: 100, barcode: '6001010', expiry: '2025-09-10' },
  { id: 'D-02', name: 'Paracetamol 1g', generic: 'Paracetamol', form: 'Tablet', category: 'Analgesic', price: 200, stock: 540, reorder: 150, barcode: '6001011', expiry: '2025-08-01' },
  { id: 'D-03', name: 'Metformin 500mg', generic: 'Metformin', form: 'Tablet', category: 'Antidiabetic', price: 350, stock: 210, reorder: 80, barcode: '6001012', expiry: '2026-02-18' },
  { id: 'D-04', name: 'Coartem (AL)', generic: 'Artemether/Lumefantrine', form: 'Tablet', category: 'Antimalarial', price: 4500, stock: 90, reorder: 60, barcode: '6001013', expiry: '2025-07-28' },
  { id: 'D-05', name: 'ORS Sachets', generic: 'Oral Rehydration Salts', form: 'Sachet', category: 'Rehydration', price: 300, stock: 1200, reorder: 200, barcode: '6001014', expiry: '2027-01-05' },
  { id: 'D-06', name: 'Zinc 20mg', generic: 'Zinc Sulphate', form: 'Tablet', category: 'Supplement', price: 150, stock: 800, reorder: 200, barcode: '6001015', expiry: '2026-06-30' },
  { id: 'D-07', name: 'Ibuprofen 400mg', generic: 'Ibuprofen', form: 'Tablet', category: 'Analgesic', price: 300, stock: 45, reorder: 100, barcode: '6001016', expiry: '2025-11-12' },
  { id: 'D-08', name: 'Omeprazole 20mg', generic: 'Omeprazole', form: 'Capsule', category: 'Antacid', price: 700, stock: 260, reorder: 80, barcode: '6001017', expiry: '2026-03-22' },
  { id: 'D-09', name: 'Cetirizine 10mg', generic: 'Cetirizine', form: 'Tablet', category: 'Antihistamine', price: 250, stock: 190, reorder: 70, barcode: '6001018', expiry: '2026-01-15' },
  { id: 'D-10', name: 'Vitamin C 500mg', generic: 'Ascorbic Acid', form: 'Tablet', category: 'Vitamin', price: 180, stock: 640, reorder: 150, barcode: '6001019', expiry: '2026-09-01' },
  { id: 'D-11', name: 'Ciprofloxacin 500mg', generic: 'Ciprofloxacin', form: 'Tablet', category: 'Antibiotic', price: 800, stock: 30, reorder: 60, barcode: '6001020', expiry: '2025-10-05' },
  { id: 'D-12', name: 'Cough Syrup 100ml', generic: 'Guaifenesin', form: 'Syrup', category: 'Analgesic', price: 5500, stock: 120, reorder: 40, barcode: '6001021', expiry: '2026-04-18' },
  { id: 'D-13', name: 'Antacid Suspension', generic: 'Aluminium Hydroxide', form: 'Syrup', category: 'Antacid', price: 4000, stock: 75, reorder: 30, barcode: '6001022', expiry: '2026-05-20' },
  { id: 'D-14', name: 'Multivitamin', generic: 'Multivitamin', form: 'Tablet', category: 'Vitamin', price: 350, stock: 410, reorder: 100, barcode: '6001023', expiry: '2026-08-10' },
];

// --- Suppliers / Vendors (restock) ---
export const MOCK_SUPPLIERS = [
  'Quality Chemicals Ltd',
  'Cipla QCIL',
  'Abacus Parenteral Drugs',
  'JMS (Joint Medical Store)',
  'Kampala Pharmaceutical Industries',
  'Medipharm Uganda',
];

// --- Payment methods (POS) ---
export const PAYMENT_METHODS = [
  { value: 'cash', label: 'Cash' },
  { value: 'mtn', label: 'MTN Mobile Money' },
  { value: 'airtel', label: 'Airtel Money' },
  { value: 'card', label: 'Card' },
];

// --- Expenses ---
export const EXPENSE_CATEGORIES = ['Rent', 'Salaries', 'Utilities', 'Restocking', 'Transport', 'Licences', 'Marketing', 'Other'];

export const MOCK_EXPENSES = [
  { id: 'E-01', category: 'Rent', description: 'Monthly shop rent', amount: 1200000, date: '2025-07-01', paidBy: 'Achieng Grace' },
  { id: 'E-02', category: 'Salaries', description: 'Staff salaries (3)', amount: 2400000, date: '2025-07-01', paidBy: 'Achieng Grace' },
  { id: 'E-03', category: 'Restocking', description: 'Order from Quality Chemicals', amount: 3850000, date: '2025-07-03', paidBy: 'Kirabo Joan' },
  { id: 'E-04', category: 'Utilities', description: 'Electricity & water', amount: 320000, date: '2025-07-05', paidBy: 'Achieng Grace' },
  { id: 'E-05', category: 'Transport', description: 'Delivery boda fees', amount: 85000, date: '2025-07-06', paidBy: 'Mugisha Brian' },
  { id: 'E-06', category: 'Licences', description: 'NDA renewal', amount: 450000, date: '2025-07-08', paidBy: 'Achieng Grace' },
];

// --- Recent sales (POS history / reports) ---
export const MOCK_SALES = [
  { id: 'S-2401-0042', time: '10:24', items: 3, total: 12400, method: 'cash', cashier: 'Okello Daniel', customer: 'Walk-in' },
  { id: 'S-2401-0041', time: '10:11', items: 1, total: 4500, method: 'mtn', cashier: 'Okello Daniel', customer: 'Nakato S.' },
  { id: 'S-2401-0040', time: '09:52', items: 5, total: 23800, method: 'airtel', cashier: 'Mugisha Brian', customer: 'Walk-in' },
  { id: 'S-2401-0039', time: '09:40', items: 2, total: 900, method: 'cash', cashier: 'Okello Daniel', customer: 'Walk-in' },
  { id: 'S-2401-0038', time: '09:18', items: 4, total: 15600, method: 'card', cashier: 'Mugisha Brian', customer: 'Kizza R.' },
];

// --- Dashboard KPIs ---
export const DASHBOARD_STATS = {
  salesToday: 486200,
  transactions: 42,
  itemsSold: 118,
  expensesToday: 405000,
};

// Top selling products (reports)
export const TOP_PRODUCTS = [
  { name: 'Paracetamol 1g', qty: 240, revenue: 48000 },
  { name: 'Coartem (AL)', qty: 62, revenue: 279000 },
  { name: 'Amoxicillin 500mg', qty: 180, revenue: 90000 },
  { name: 'ORS Sachets', qty: 320, revenue: 96000 },
  { name: 'Vitamin C 500mg', qty: 150, revenue: 27000 },
];

// Weekly sales vs expenses (reports)
export const WEEKLY_TREND = [
  { day: 'Mon', sales: 420000, expenses: 120000 },
  { day: 'Tue', sales: 510000, expenses: 90000 },
  { day: 'Wed', sales: 380000, expenses: 260000 },
  { day: 'Thu', sales: 640000, expenses: 150000 },
  { day: 'Fri', sales: 720000, expenses: 110000 },
  { day: 'Sat', sales: 890000, expenses: 340000 },
  { day: 'Sun', sales: 310000, expenses: 60000 },
];

// --- Top navigation modules (role-aware) ---
export const NAV_MODULES = [
  { key: 'dashboard', label: 'Dashboard', icon: 'LayoutGrid', roles: ['pharmacy_admin', 'cashier', 'pharmacist', 'stock_controller'] },
  { key: 'pos', label: 'POS', icon: 'ShoppingCart', roles: ['pharmacy_admin', 'cashier', 'pharmacist'] },
  { key: 'inventory', label: 'Inventory', icon: 'Boxes', roles: ['pharmacy_admin', 'stock_controller'] },
  { key: 'catalog', label: 'Drug Catalog', icon: 'Pill', roles: ['pharmacy_admin', 'cashier', 'pharmacist', 'stock_controller'] },
  { key: 'expenses', label: 'Expenses', icon: 'Wallet', roles: ['pharmacy_admin'] },
  { key: 'reports', label: 'Reports', icon: 'BarChart3', roles: ['pharmacy_admin', 'stock_controller'] },
  { key: 'admin', label: 'Admin', icon: 'Building2', roles: ['super_user', 'pharmacy_admin'] },
];

export const formatUGX = (n) => 'UGX ' + (Math.round(n) || 0).toLocaleString('en-UG');
export const methodLabel = (v) => (PAYMENT_METHODS.find((m) => m.value === v) || {}).label || v;
